import { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  delay?: number;
  className?: string;
}

export const SearchInput = ({
  value,
  onChange,
  placeholder = "Tìm kiếm...",
  delay = 400,
  className = "",
}: SearchInputProps) => {
  const [local, setLocal] = useState(value);

  useEffect(() => {
    setLocal(value);
  }, [value]);

  useEffect(() => {
    if (local === value) return;
    const timer = setTimeout(() => onChange(local), delay);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [local, delay]);

  return (
    <div
      className={`flex items-center border border-gray-200 rounded-xl focus-within:border-blue-500 transition-colors duration-300 ${className}`}
    >
      <input
        type="text"
        value={local}
        onChange={(e) => setLocal(e.target.value)}
        className="flex-1 p-2 focus:outline-none placeholder:text-sm placeholder:tracking-tighter placeholder:text-gray-400"
        placeholder={placeholder}
      />
      <CiSearch className="text-xl text-gray-700 mr-2 shrink-0" />
    </div>
  );
};
